import * as go from 'gojs';
import { getFont } from '../utils/font';
import { locationBinding } from '../utils';

const $ = go.GraphObject.make;

const HighlightTextbox = $(
  go.Node,
  {
    layerName: 'Foreground',
    name: 'NODEPARENT',
    selectionAdorned: false,
  },
  locationBinding(),
  $(
    go.Panel,
    'Auto',
    {
      isPanelMain: true,
    },
    $(
      go.Shape,
      'RoundedRectangle',
      { stroke: null },
      new go.Binding('fill', 'color', (color) => color),
    ),
    $(
      go.Panel,
      'Vertical',
      $(
        go.TextBlock,
        {
          margin: new go.Margin(8, 8, 8, 8),
          alignment: go.Spot.Left,
          stroke: '#FFFFFF',
        },
        getFont({ weight: 700 }),
        new go.Binding('text', 'title', (title) => title),
      ),
      $(
        go.TextBlock,
        {
          alignment: go.Spot.Left,
          margin: new go.Margin(0, 8, 8, 8),
          stroke: '#FFFFFF',
          width: 200,
        },
        getFont({ weight: 500 }),
        new go.Binding('text', 'body', (body) => body),
        new go.Binding('width', 'body', (body) =>
          body.length <= 12 ? 60 : 200,
        ),
        new go.Binding('visible', 'body', (body) => body.length > 0),
      ),
    ),
  ),
);

export default HighlightTextbox;
